export const RouteConfig = {
  Overview: {
    path: 'overview',
    title: 'Overview',
    i18nKey: 'overview.title',
    pageViewRequest: 'overview',
  },
  Findings: {
    path: 'findings',
    title: 'Findings',
    i18nKey: 'findings.title',
    pageViewRequest: 'findings',
  },
  Audits: {
    path: 'audits',
    title: 'Audits',
    i18nKey: 'audits.title',
    pageViewRequest: 'audits',
  },
  Certificates: {
    path: 'certificates',
    title: 'Certificates',
    i18nKey: 'certificates.title',
    pageViewRequest: 'certificates',
  },
  Contracts: {
    path: 'contracts',
    title: 'Contracts',
    i18nKey: 'contracts.title',
    pageViewRequest: 'contracts',
  },
  Financials: {
    path: 'financials',
    title: 'Financials',
    i18nKey: 'financials.title',
    pageViewRequest: 'financials',
  },
  Schedule: {
    path: 'schedule',
    title: 'Schedule',
    i18nKey: 'schedule.title',
    pageViewRequest: 'schedule',
  },
  Actions: {
    path: 'actions',
    title: 'Actions',
    i18nKey: 'actions.title',
    pageViewRequest: 'actions',
  },
  Notifications: {
    path: 'notifications',
    title: 'Notifications',
    i18nKey: 'notifications.title',
    pageViewRequest: 'notifications',
  },
  Settings: {
    path: 'settings',
    title: 'Settings',
    i18nKey: 'settings.title',
    pageViewRequest: 'settings',
  },
  ExternalApps: {
    path: 'apps',
    title: 'External Apps',
    i18nKey: 'apps.title',
    pageViewRequest: 'apps',
  },
  Welcome: {
    path: 'welcome',
    title: 'Welcome',
    i18nKey: 'welcome.title',
    pageViewRequest: 'welcome',
  },
  Logout: {
    path: 'logout',
    title: 'Logout',
    i18nKey: 'logout.title',
    pageViewRequest: 'logout',
  },
  Error: {
    path: 'error',
    title: 'Error',
    i18nKey: 'error',
    pageViewRequest: 'error',
  },
  Maintenance: {
    path: 'maintenance',
    title: 'Maintenance',
    i18nKey: 'maintenance.title',
    pageViewRequest: 'maintenance',
  },
} as const;

export type RouteConfigKey = keyof typeof RouteConfig;

export interface RouteData {
  path: string;
  title: string;
  i18nKey: string;
  pageViewRequest: string;
}

export function createRouteTitleMap(): Record<string, string> {
  const map: Record<string, string> = {
    '': RouteConfig.Overview.title, // Default route
  };

  Object.values(RouteConfig).forEach((route) => {
    map[route.path] = route.title;
  });

  return map;
}

export function getRouteDataByPath(path: string): RouteData | undefined {
  const normPath = path.startsWith('/') ? path.substring(1) : path;

  const key = Object.keys(RouteConfig).find(
    (configKey) => RouteConfig[configKey as RouteConfigKey].path === normPath,
  ) as RouteConfigKey | undefined;

  if (key) {
    return RouteConfig[key];
  }

  const nestedKey = Object.keys(RouteConfig).find((configKey) =>
    normPath.startsWith(`${RouteConfig[configKey as RouteConfigKey].path}/`),
  ) as RouteConfigKey | undefined;

  if (nestedKey) {
    return RouteConfig[nestedKey];
  }

  return undefined;
}
